import { render, staticRenderFns } from "./index.vue?vue&type=template&id=031c0c09"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031c0c09')) {
      api.createRecord('031c0c09', component.options)
    } else {
      api.reload('031c0c09', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=031c0c09", function () {
      api.rerender('031c0c09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/newsTypeSet/index.vue"
export default component.exports